export const FIRST_PROJECT = {
  descripcion: "",
  img: "/img/perf-mundial.png",
  alt: "",
  tecnologias: [
    "React",
    "Mongo",
    "Mercado Pago API",
    "Node",
    "Styled-components",
    "Typescript",
    "Docker",
  ],
  titulo: "",
  github: "",
  web: "https://www.perfumeriamundial.ar/",
};
export const dataProjects: (typeof FIRST_PROJECT)[] = [
  FIRST_PROJECT,

  {
    descripcion: "",
    img: "/img/rohelaw.com.ar.png",
    alt: "proyecto Rohelaw",
    tecnologias: ["Javascript", "HTML", "CSS"],
    titulo: "ROHELAW WEBSITE",
    github: "https://github.com/CarelessAsado/sworntranslation_site",
    web: "http://rohelaw.com.ar/",
  },
];
